import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as Delete2Icon } from '@enamelai/design-system/icons/Delete2'

type PhoneManagementDeleteNumberModalProps = {
  show: boolean
  phoneNumber?: string
  onCancel: () => void
  onDelete: () => void
  deleteDisabled?: boolean
}

const PhoneManagementDeleteNumberModal: React.FC<
  PhoneManagementDeleteNumberModalProps
> = ({ show, phoneNumber, onCancel, onDelete, deleteDisabled = false }) => {
  const numberLabel = phoneNumber?.trim() || 'this number'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="sm"
      variant="confirmation"
      title="Delete number"
      icon={<Delete2Icon width={16} height={16} aria-hidden="true" />}
      iconTone="danger"
      description={[
        `Are you sure you want to delete ${numberLabel}?`,
        'Once deleted, this number will be permanently deactivated and removed from phone management.',
        'Deleting this number means you can no longer:',
      ]}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      primaryDisabled={deleteDisabled}
      onPrimaryClick={() => {
        onDelete()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    >
      <ul className="ds-modal__list">
        <li>Make or receive calls and faxes</li>
        <li>Send or receive SMS messages</li>
      </ul>
      <p className="ds-modal__description">This action can&apos;t be undone.</p>
    </Modal>
  )
}

export default PhoneManagementDeleteNumberModal
